import { Box, Typography } from '@mui/material'
import React from 'react'

function SubjectStatics({staticsData}) {
    const {subjectName, totalSubscribers, totalPaidSubscribers} = staticsData;
  return (
    <Box sx={{
        backgroundColor: '#f5f5f5',
        margin: 1
    }}>
        <Typography variant="h4" sx={{ padding: 1 }}>
         {subjectName}
        </Typography>
        <Typography variant="h6" sx={{ padding: 1 }}>
         {`Subscribed Students: ${totalSubscribers}`}
        </Typography>
        <Typography variant="h6" sx={{ padding: 1 }}>
         {`Paid Students: ${totalPaidSubscribers}`}
        </Typography>
    </Box>
  )
}

export default SubjectStatics